export default __webpack_public_path__ + "static/media/wakanim.ba063cfa.jpg";